import api from '@/api';
import { Message } from 'element-ui';
import moment from 'moment';
// 创建简历
export const createdCv = async ({ dispatch, state, commit }, cvToken) => {
  let { cvInfo } = state;
  let {
    basic_info = {},
    submodule_info = {},
    format_info = {}
  } = cvInfo;

  let params = {
    basic_info: {
      ...basic_info,
      kind: '',
      token: '',
      created_at: '',
      updated_at: ''
    },
    submodule_info: {
      ...submodule_info
    },
    format_info,
    operation_type: ''
  };
  let res = await api.cvsEditor.createCv(params);
  if (res.code !== 1000) {
    Message.error(res.message);
    return res;
  }
  cvInfo = res.data || {};
  commit('setCvToken', cvInfo.basic_info.token);
  commit('setCvInfo', cvInfo);
  // 重置url
  window.history.replaceState('', '', `/cvs/${cvInfo.basic_info.token}/editor`);
  return res;
}


// 基本信息
export const getProfile = async ({ dispatch, state, commit }, cvToken) => {
  let { basic_info = {} } = state;
  cvToken = cvToken || basic_info.token;
  let params = {
    cv_kind: basic_info.kind || null,
    type: basic_info.mentor_id ? 'mentor' : ''
  };
  if(state.mentor){
    params['type'] = 'mentor'
  }
  let res = await api.cvsEditor.getProfile(cvToken, params);
  let profile = (res.data && res.data.profile) || {};
  let { format_pref } = profile;
  if (!format_pref) {
    format_pref = { age_birthday: { chosen: 'birthday', date_format: 'yyyy_d' } };
  }
  profile = {
    ...profile,
    format_pref
  };
  commit('setProfile', profile);
  return res;
}
export const createdProfile = async ({ dispatch, state, commit }) => {
  let { cvInfo, cvToken, profile, CONST_KIND } = state;
  let { basic_info } = cvInfo;
  cvToken = basic_info.token;
  // 未创建简历
  if (CONST_KIND.indexOf(basic_info.kind) !== -1) {
    await dispatch('createdCv');
  }
  let res = await api.cvsEditor.createProfile(cvToken, profile);
  if (res.code === 1000) {
    profile = res.data.profile || {};
  }
  commit('setProfile', profile);
  return res;
}
export const editProfile = async ({ dispatch, state, commit }) => {
  state = JSON.parse(JSON.stringify(state));
  const constKey = ['avatar_url', 'email', 'phone', 'address', 'gender', 'current_job', 'exp_job', 'city', 'political_status', 'height', 'weight', 'marriage', 'hometown', 'username', 'expected_salary', 'ethnic', 'homepage', 'linked_in', 'wechat', 'birthday', 'format_pref'];
  let { cvInfo, cvToken, profile, CONST_KIND } = state;
  let { basic_info } = cvInfo;
  cvToken = basic_info.token;
  delete profile.id;
  let { format_pref } = profile

  format_pref = {
    age_birthday: {
      chosen: format_pref.age_birthday.chosen,
      date_format: format_pref.age_birthday.chosen === 'birthday' ? 'yyyy_d' : ''
    }
  };
  profile.format_pref = format_pref;

  // 年龄或者生日修改
  if (profile.birthday) {
    profile.birthday = moment(profile.birthday).format('YYYY-MM-DD');
  }

  for (let i in profile) {
    if (constKey.indexOf(i) < 0) delete profile[i];
  }

  if(state.mentor){
    params['is_mentor'] = state.mentor
  }

  let res = await api.cvsEditor.editProfile(cvToken, profile);
  if (res.code === 1000) {
    profile = res.data.profile || {};
  }
  return res;
}

// 教育模块
export const getEdusList = async ({ dispatch, state, commit }, cvToken) => {
  let { cvInfo, CONST_KIND } = state;
  if (!cvInfo.submodule_info.edus_ids || !cvInfo.submodule_info.edus_ids.length) {
    commit('setEdus', []);
    return false;
  }
  let params = {
    lang: state.cvInfo.basic_info.lang,
    type: state.cvInfo.basic_info.kind,
    ids: cvInfo.submodule_info.edus_ids.join(',')
  };
  if(state.mentor){
    params['type'] = 'mentor'
  }
  let res = await api.cvsEditor.getEdusList(params);
  let edus = res.data.edus || [];
  commit('setEdus', edus);
  // 从新渲染list
  dispatch('setList');
  return res;
}
export const createdEdu = async ({ dispatch, state, commit }, queryData) => {
  let { cvInfo, CONST_KIND } = state;
  let res = {};
  res = await api.cvsEditor.createEdu(queryData);
  if (res.code !== 1000) {
    Message.error(res.message);
    return res;
  }
  let edus = res.data.edus || {};
  let edus_ids = [ ...cvInfo.submodule_info.edus_ids ];
  edus_ids.push(edus.id);
  edus_ids = edus_ids.filter(item=>item);

  // 修改排序
  let sections_position = JSON.parse(JSON.stringify(cvInfo.submodule_info.sections_position));
  let isPush = true;
  for (let i = sections_position.length - 1; i >= 0; i--) {
    if (sections_position[i].type === 'edus') {
      isPush = false;
      // sections_position.splice(i, 1);
      break;
    }
  }
  if (isPush) {
    sections_position.push({
      id: null,
      type: 'edus',
      info_ids: edus_ids
    });
  }
  // 更新cvInfo
  cvInfo = {
    ...cvInfo,
    submodule_info: {
      ...cvInfo.submodule_info,
      edus_ids: [
        ...(cvInfo.submodule_info.edus_ids || []),
        edus.id
      ]
    }
  };
  commit('setCvInfo', cvInfo);
  // 创建简历
  if (CONST_KIND.indexOf(cvInfo.basic_info.kind) !== -1) {
    res = await dispatch('createdCv');
  }
  // 更新简历
  else {
    res = await dispatch('updatedCvInfo', 'submodule_info');
  }
  dispatch('getEdusList');
  return res;
}
export const editEdu = async ({ dispatch, state, commit }, queryData) => {
  let id = queryData.id;
  delete queryData.id;
  let res = {};
  if(state.mentor){
    queryData['is_mentor'] = state.mentor
  }
  res = await api.cvsEditor.editEdu(id, queryData);
  dispatch('getEdusList');
  return res;
}
export const deleteEdu = async ({ dispatch, state, commit }, { id, params, data }) => {
  let res = await api.cvsEditor.deleteEdu(id, params, data);
  if(res.code === 1000){
    dispatch('getEdusList');
  }
  return res;
}

// 工作模块
export const getWorksList = async ({ dispatch, state, commit }, cvToken) => {
  let { cvInfo, CONST_KIND } = state;
  if (!cvInfo.submodule_info.works_ids || !cvInfo.submodule_info.works_ids.length) {
    commit('setWorks', []);
    return false;
  }
  let params = {
    lang: state.cvInfo.basic_info.lang,
    type: state.cvInfo.basic_info.kind,
    ids: cvInfo.submodule_info.works_ids.join(',')
  };
  if(state.mentor){
    params['type'] = 'mentor'
  }
  let res = await api.cvsEditor.getWorksList(params);
  let works = res.data.works || [];
  commit('setWorks', works);
  // 从新渲染list
  dispatch('setList');
  return res;
}
export const createdWork = async ({ dispatch, state, commit }, queryData) => {
  let { cvInfo, CONST_KIND } = state;
  let res = {};
  res = await api.cvsEditor.createWork(queryData);
  if (res.code !== 1000) {
    Message.error(res.message);
    return res;
  }
  let works = res.data.works || {};
  // 更新cvInfo
  let works_ids = [
    ...(cvInfo.submodule_info.works_ids || []),
    works.id
  ];
  works_ids = works_ids.filter(item=>item);

  // 修改排序
  let sections_position = JSON.parse(JSON.stringify(cvInfo.submodule_info.sections_position));
  let isPush = true;
  for (let i = sections_position.length - 1; i >= 0; i--) {
    if (sections_position[i].type === 'works') {
      isPush = false;
      // sections_position.splice(i, 1);
      break;
    }
  }
  if (isPush) {
    sections_position.push({
      id: null,
      type: 'works',
      info_ids: works_ids
    });
  }

  cvInfo = {
    ...cvInfo,
    submodule_info: {
      ...cvInfo.submodule_info,
      works_ids
    }
  };
  commit('setCvInfo', cvInfo);
  // 创建简历
  if (CONST_KIND.indexOf(cvInfo.basic_info.kind) !== -1) {
    res = await dispatch('createdCv');
  }
  // 更新简历
  else {
    res = await dispatch('updatedCvInfo', 'submodule_info');
  }
  dispatch('getWorksList');
  return res;
}
export const editWork = async ({ dispatch, state, commit }, queryData) => {
  let id = queryData.id;
  delete queryData.id;
  let res = {};
  if(state.mentor){
    queryData['is_mentor'] = state.mentor
  }
  res = await api.cvsEditor.editWork(id, queryData);
  dispatch('getWorksList');
  return res;
}
export const deleteWork = async ({ dispatch, state, commit }, { id, params, data }) => {
  let res = await api.cvsEditor.deleteWork(id, params, data);
  if(res.code === 1000){
    dispatch('getWorksList');
  }
  return res;
}

// org模块
export const getOrgsList = async ({ dispatch, state, commit }, cvToken) => {
  let { cvInfo, CONST_KIND } = state;
  if (!cvInfo.submodule_info.orgs_ids || !cvInfo.submodule_info.orgs_ids.length) {
    commit('setOrgs', []);
    return false;
  }
  let params = {
    lang: state.cvInfo.basic_info.lang,
    type: state.cvInfo.basic_info.kind,
    ids: cvInfo.submodule_info.orgs_ids.join(',')
  };
  if(state.mentor){
    params['type'] = 'mentor'
  }
  let res = await api.cvsEditor.getOrgsList(params);
  let orgs = res.data.orgs || [];
  commit('setOrgs', orgs);
  // 从新渲染list
  dispatch('setList');
  return res;
}
export const createdOrg = async ({ dispatch, state, commit }, queryData) => {
  let { cvInfo, CONST_KIND } = state;
  let res = {};
  //创建小模块
  res = await api.cvsEditor.createOrg(queryData);
  if (res.code !== 1000) {
    Message.error(res.message);
    return res;
  }
  let org = res.data.org || {};
  // 创建简历
  if (CONST_KIND.indexOf(cvInfo.basic_info.kind) !== -1) {
    res = await dispatch('createdCv');
  }
  // 更新cvInfo
  let orgs_ids = [
    ...(cvInfo.submodule_info.orgs_ids || []),
    org.id
  ];
  orgs_ids = orgs_ids.filter(item=>item);
  // 修改排序
  let sections_position = JSON.parse(JSON.stringify(cvInfo.submodule_info.sections_position));
  let isPush = true;
  for (let i = sections_position.length - 1; i >= 0; i--) {
    if (sections_position[i].type === 'orgs') {
      isPush = false;
      // sections_position.splice(i, 1);
      break;
    }
  }
  if (isPush) {
    sections_position.push({
      id: null,
      type: 'orgs',
      info_ids: orgs_ids
    });
  }
  // 修改cvinfo
  cvInfo = {
    ...cvInfo,
    submodule_info: {
      ...cvInfo.submodule_info,
      sections_position,
      orgs_ids
    }
  };
  commit('setCvInfo', cvInfo);
  // 更新简历
  res = await dispatch('updatedCvInfo', 'submodule_info');
  dispatch('getOrgsList');
  return res;
}
export const editOrg = async ({ dispatch, state, commit }, queryData) => {
  let id = queryData.id;
  delete queryData.id;
  // queryData.cv_token = state.cvToken;
  let res = {};
  if(state.mentor){
    queryData['is_mentor'] = state.mentor
  }
  res = await api.cvsEditor.editOrg(id, queryData);
  dispatch('getOrgsList');
  return res;
}
export const deleteOrg = async ({ dispatch, state, commit }, { id, params, data }) => {
  let res = await api.cvsEditor.deleteOrg(id, params, data);
  if(res.code === 1000){
    dispatch('getOrgsList');
  }
  return res;
}

// other extras
export const getExtrasList = async ({ dispatch, state, commit }, ) => {
  state = JSON.parse(JSON.stringify(state));
  let { cvInfo, CONST_KIND } = state;
  let { submodule_info, basic_info } = cvInfo;
  let { sections_position } = submodule_info;
  let res = {};
  let key = ['language_id', 'certificate_id', 'other_id', 'interest_id', 'skill_id'];
  let ids = [];
  key.forEach(item => {
    if (submodule_info[item]) {
      ids.push(submodule_info[item]);
    }
  });
  let params = {
    type: basic_info.kind,
    language_id: submodule_info['language_id'],
    certificate_id: submodule_info['certificate_id'],
    other_id: submodule_info['other_id'],
    interest_id: submodule_info['interest_id'],
    skill_id: submodule_info['skill_id'],
  };
  if(state.mentor){
    params['type'] = 'mentor'
  }
  res = await api.cvsEditor.getExtrasList(params);
  if (res.code !== 1000) {
    return res;
  }
  commit('setOthers', res.data.others);
  dispatch('setList');
  return res;
}
export const createdExtra = async ({ dispatch, state, commit }, queryData) => {
  state = JSON.parse(JSON.stringify(state));
  let { cvInfo, CONST_KIND } = state;
  let { submodule_info } = cvInfo;
  let { sections_position } = submodule_info;
  let res = {};
  // 创建简历
  if (CONST_KIND.indexOf(cvInfo.basic_info.kind) !== -1) {
    res = await dispatch('createdCv');
  }
  // 创建模块
  res = await api.cvsEditor.createExtra(queryData);
  if (res.code !== 1000) {
    Message.error(res.message);
    return res;
  }
  let others = res.data.others;
  // 修改排序
  let isPushPosition = true;
  sections_position.forEach(item => {
    if (item.type === 'extras') {
      isPushPosition = false;
    }
  });
  if (isPushPosition) {
    sections_position.push({
      id: null,
      type: 'extras',
      info_ids: []
    });
  }
  // 添加id
  for (let key in others) {
    submodule_info[key + '_id'] = others[key].id;
  }
  cvInfo = {
    ...cvInfo,
    submodule_info: {
      ...submodule_info,
      sections_position
    }
  };
  commit('setCvInfo', cvInfo);
  dispatch('updatedCvInfo', 'submodule_info');
  return res;
}
export const editExtra = async ({ dispatch, state, commit }, queryData) => {
  state = JSON.parse(JSON.stringify(state));
  let { cvInfo, CONST_KIND } = state;
  let { submodule_info } = cvInfo;
  let { sections_position } = submodule_info;
  if(state.mentor){
    queryData['is_mentor'] = state.mentor
  }
  let res = {};
  res = await api.cvsEditor.editExtra(queryData);
  dispatch('getExtrasList');
  return res;
}
export const deleteExtra = async ({ dispatch, state, commit }, params) => {
  let res = await api.cvsEditor.deleteExtra(params);
  if(res.code === 1000){
    dispatch('getExtrasList');
  }
  return res;
}

// 自定义模块-项目经历，研究经历
export const getCustomList = async ({ dispatch, state, commit }, data) => {
  // 常用变量提前声明
  let res = {};
  let params = {};
  console.log('setInfos=>>>>> data >>>>', data)
  if (!data.info_ids || !data.info_ids.length) {
    commit('setInfos', { key: data.key || data.id, infos: []});
    return false;
  }
  let category = data.type || 'custom';
  params = {
    info_ids: (data.info_ids || []).join(',')
  };
  if(state.mentor){
    params['type'] = 'mentor'
  }
  res = await api.cvsEditor.getCustomInfoList(data.id, params);
  if (res.code !== 1000) return false;
  let infos = res.data.infos;
  console.log('setInfos=>>>>>>>>>', infos)
  commit('setInfos', { key: data.key || data.id, infos});
  // 从新渲染list
  dispatch('setList');
  return res;

}

export const createdCustom = async ({ dispatch, state, commit }, { editModuleData, queryData }) => {
  // 需要先获取本人经历库
  await dispatch('getCustomJL');
  editModuleData = JSON.parse(JSON.stringify(editModuleData));
  queryData = JSON.parse(JSON.stringify(queryData));
  let { cvInfo, CONST_KIND, experience } = state;
  let { submodule_info } = cvInfo;
  let { sections_position, custom_sections_ids, custom_sections_titles } = submodule_info;
  let res = {};
  // 判断是否是项目或者研究
  console.log('当前编辑数据editModuleData=>>>',JSON.parse(JSON.stringify(editModuleData)))
  console.log('queryData=>>>',JSON.parse(JSON.stringify(queryData)))
  console.log('经历库数据experience=>>>',JSON.parse(JSON.stringify(experience)))
  console.log('editModuleData.type=?>>>>',editModuleData.type)
  if (editModuleData.type !== 'custom') {

    //简历中是否有此模块
    let cvHasModule = sections_position.filter(item=>item.type===editModuleData.type).length;
    //经历库中是否有此数据
    let experienceModule = [];
    let experienceModuleId = '';
    Object.keys(experience).forEach(key=>{
      //里边可能包含对象
      console.log(experience[key].category ===  editModuleData.type)
      if(!(experience[key] instanceof Array )&& experience[key].category === editModuleData.type){
        experienceModule = experienceModule.concat(experience[key].infos);
        experienceModuleId = experience[key].id
      }
    })
    //拿到是否是添加状态
    let isAddModule = true;

    //经历库中没有此数据，需要创建大模块（创建时会自动创建小模块）
    if(!experienceModule.length){
      let createdCustomData={
        ...queryData,
        category:editModuleData.type
      }
      createdCustomRes = await api.cvsEditor.createCustom(createdCustomData);

      console.log('createdCustomRes=>>',createdCustomRes)
    }else if(!cvHasModule){
      //经历库中有此模块，简历中无此模块
      console.log('experienceModule=>>>',experienceModule)
      //同步大模块id到编辑数据中
      editModuleData.id = experienceModuleId;
      // 插入大模块id到排序中
      sections_position.push({
        id:experienceModuleId,
        info_ids: [],
        type: editModuleData.type
      })
      if(!editModuleData.key){
        editModuleData.key = experienceModuleId;
      }
      custom_sections_ids.push(experienceModuleId)
      custom_sections_ids = [...Array.from(new Set(custom_sections_ids))]
      console.log('custom_sections_ids=><>>',custom_sections_ids)
      cvInfo = {
        ...cvInfo,
        submodule_info: {
          ...submodule_info,
          sections_position,
          custom_sections_ids
        }
      };
      //同步vuex数据
      commit('setCvInfo', cvInfo);
      // 走创建子模块，再更新cvinfo
      return await dispatch('createdCustomInfo', { editModuleData, queryData });
    }


    // 循环经历库模块
    for (let i in experience) {
      // 存在同样的模块
      if (experience[i].category === editModuleData.type) {
        // 修改cvinfo

        // 经历库同模块id
        let id = experience[i].id;
        // 说明简历的这个模块不是本人的，sample
        if (editModuleData.id != id) {
          // let { submodule_info } = cvInfo;
          // let { sections_position, custom_sections_ids, custom_sections_titles } = submodule_info;
          // 过滤排序
          for (let i in sections_position) {
            if (sections_position[i].id === editModuleData.id) {
              sections_position[i].id = id;
            }
          }
          console.log('sections_position=>>>',JSON.parse(JSON.stringify(sections_position)))
          custom_sections_ids = [
            ...(custom_sections_ids.filter(item => item !== editModuleData.id)),
            id
          ]
          custom_sections_ids = [...Array.from(new Set(custom_sections_ids))]
          console.log('custom_sections_ids=><>>',custom_sections_ids)
          editModuleData.id = id;
          cvInfo = {
            ...cvInfo,
            submodule_info: {
              ...submodule_info,
              sections_position,
              custom_sections_ids
            }
          };
          console.log('experience=>>',JSON.parse(JSON.stringify(experience)))
          console.log('cvInfo=>>',JSON.parse(JSON.stringify(cvInfo)))
          commit('setCvInfo', cvInfo);
        }
        return await dispatch('createdCustomInfo', { editModuleData, queryData });
      }
    }
  }
  if (editModuleData.type !== 'custom') {
    queryData.category = editModuleData.type;
  }

  // 正常
  queryData.section_title = editModuleData.title || '未命名模块';
  res = await api.cvsEditor.createCustom(queryData);
  if (res.code !== 1000) return res;
  // 创建简历
  if (CONST_KIND.indexOf(cvInfo.basic_info.kind) !== -1) {
    res = await dispatch('createdCv');
  }
  let custom_section = res.data.custom_section || [];
  // 修改排序
  // let sections_position = cvInfo.submodule_info.sections_position;
  // let custom_sections_ids = cvInfo.submodule_info.custom_sections_ids;
  let info_ids = [];
  if (editModuleData.type !== 'custom') {
    let obj = {};
    let isPush = true;
    // 判断是否不是自己经历
    for (let i in sections_position) {
      // 不是自己经历
      if (sections_position[i].type === editModuleData.type) {
        isPush = false;
        custom_sections_ids[custom_sections_ids.indexOf(sections_position[i].id)] = custom_section.id;
        sections_position[i].id = custom_section.id;
        for (let j in custom_section.infos) {
          info_ids.push(custom_section.infos[j].id);
        }
        sections_position[i].info_ids = info_ids;
      }
    }
    if (isPush) {
      for (let j in custom_section.infos) {
        info_ids.push(custom_section.infos[j].id);
      }
      sections_position.push({
        id: custom_section.id,
        type: editModuleData.type,
        info_ids: info_ids
      });
      custom_sections_ids.push(custom_section.id);
    }
  }
  // 普通自定义模块自定义经历
  else {
    for (let i = 0; i < custom_section.infos.length; i++) {
      info_ids.push(custom_section.infos[i].id);
    }
    sections_position.push({
      id: custom_section.id,
      type: custom_section.category || 'custom',
      info_ids
    });
    custom_sections_ids.push(custom_section.id);
    console.log('custom=>>>',sections_position,custom_sections_ids)

  }

  cvInfo = {
    ...cvInfo,
    submodule_info: {
      ...cvInfo.submodule_info,
      custom_sections_ids,
      sections_position
    }
  };
  commit('setCvInfo', cvInfo);
  res = await dispatch('updatedCvInfo', 'submodule_info');

  //如果没有info_ids就直接添加进去
  editModuleData.info_ids = !editModuleData.info_ids.length ? info_ids : editModuleData.info_ids;
  //没有模块id，直接添加进去
  editModuleData.id = !editModuleData.id ? custom_section.id : editModuleData.id;

  console.log('getCustomList=>>>',editModuleData)
  //重新获取简历中，自定义模块列表
  dispatch('getCustomList', editModuleData);
  //重新获取经历库，自定义模块列表
  dispatch('getCustomJL');
  return res;
}
export const createdCustomInfo = async ({ dispatch, state, commit }, { editModuleData, queryData }) => {
  state = JSON.parse(JSON.stringify(state));
  let { cvInfo, CONST_KIND } = state;
  let res = {};
  // 创建子模块
  res = await api.cvsEditor.createCustomInfo(editModuleData.id, queryData);
  if (res.code !== 1000) return res;
  let info = res.data.info || {};
  // 修改排序
  let sections_position = cvInfo.submodule_info.sections_position;
  for (let i = 0; i < sections_position.length; i++) {
    if (sections_position[i].id === editModuleData.id) {
      let info_ids = sections_position[i].info_ids || [];
      info_ids.push(info.id);
      sections_position[i].info_ids = info_ids;
      editModuleData.info_ids = info_ids;
    }
  }
  console.log('createdCustomInfo editModuleData=>>',editModuleData)
  cvInfo = {
    ...cvInfo,
    submodule_info: {
      ...cvInfo.submodule_info,
      sections_position
    }
  };
  commit('setCvInfo', cvInfo);
  // 更新cvinfo
  res = await dispatch('updatedCvInfo', 'submodule_info');
  //重新获取简历中，自定义模块列表
  dispatch('getCustomList', editModuleData);
  //重新获取经历库，自定义模块列表
  dispatch('getCustomJL');

  return res;
}
export const editCustomInfo = async ({ dispatch, state, commit }, { editModuleData, queryData }) => {
  let { cvInfo, CONST_KIND, list } = state;
  if(state.mentor){
    queryData['is_mentor'] = state.mentor
  }
  let res = {};
  res = await api.cvsEditor.editCustomInfo(editModuleData.id, editModuleData.data.id, queryData);
  if (res.code !== 1000) return res;
  dispatch('getCustomList', editModuleData);
  return res;
}
export const editCustomTitle = async ({ dispatch, state, commit }, { editModuleData, queryData }) => {
  let { cvInfo, CONST_KIND } = state;
  let res = {};
  if(state.mentor){
    queryData['is_mentor'] = state.mentor
  }
  res = await api.cvsEditor.editCustomTitle(editModuleData.id, queryData);
  if (res.code !== 1000) return res;
  return res;
}
export const deleteCustomInfo = async ({ dispatch, state, commit }, { opt, data }) => {
  let { cvInfo, CONST_KIND, experience } = state;
  let res = {};
  res = await api.cvsEditor.deleteCustomInfo(data.custom_section_id, data.id);
  if (res.code !== 1000) return res;
  // 删除大模块
  if (opt.infos.length <= 1) {
    res = await api.cvsEditor.deleteCustom(opt.id);
    delete experience[opt.id];
    commit('setExperience', experience);
  }
  // 刷新经历
  await dispatch('getCustomJL');
  return res;
}


// 经历库--JL-不需要参数
export const getEdusJL = async ({ dispatch, state, commit }, cvToken) => {
  let params = {
    lang: state.cvInfo.basic_info.lang,
  };
  let res = await api.cvsEditor.getEdusList(params);
  let experience = state.experience;
  experience = {
    ...experience,
    edus: res.data.edus || []
  }
  commit('setExperience', experience);
  return res;
}
export const getWorksJL = async ({ dispatch, state, commit }, cvToken) => {
  let params = {
    lang: state.cvInfo.basic_info.lang,
  };
  let res = await api.cvsEditor.getWorksList(params);
  let experience = state.experience;
  experience = {
    ...experience,
    works: res.data.works || []
  }
  commit('setExperience', experience);
  return res;
}
export const getOrgsJL = async ({ dispatch, state, commit }, cvToken) => {
  let params = {
    lang: state.cvInfo.basic_info.lang,
  };
  let res = await api.cvsEditor.getOrgsList(params);
  let experience = state.experience;
  experience = {
    ...experience,
    orgs: res.data.orgs || []
  }
  commit('setExperience', experience);
  return res;
}
export const getExtrasJL = async ({ dispatch, state, commit }, cvToken) => {
  let params = {
    size: 30,
    section_lang: state.cvInfo.basic_info.lang,
  };
  let res = await api.cvsEditor.getExtras(params);
  let experience = state.experience;
  let others = res.data.others || {};
  Object.keys(others).forEach(key=>{
    let bItem = others[key];
    bItem&&bItem.forEach(item=>{
      item.fType = key.substring(0,key.length-1)
    })
  })
  experience = {
    ...experience,
    extras: others
  }
  commit('setExperience', experience);
  return res;
}
export const getCustomJL = async ({ dispatch, state, commit }, cvToken) => {
  let params = {
    lang: state.cvInfo.basic_info.lang,
    size: 60
  };
  let res = await api.cvsEditor.getCustomList(params);
  if (res.code !== 1000) return false;
  let custom_sections = res.data.custom_sections;
  let experience = state.experience;
  experience = {
    ...experience
  }
  for (let i = 0; i < custom_sections.length; i++) {
    experience[custom_sections[i].id] = custom_sections[i]
  }
  commit('setExperience', experience);
  return res;
}

// 修改模块名称
export const updatedModuleName = async ({ dispatch, state, commit }, cvInfo) => {
  commit('setCvInfo', cvInfo);
  let res = await dispatch('updatedCvInfo', 'submodule_info');
  return res;
}
